import { Component, Input } from '@angular/core';
import { Main } from 'src/app/core/main/main';

@Component({
  selector: 'app-view-your-truck',
  templateUrl: './view-your-truck.component.html',
  styleUrls: ['./view-your-truck.component.scss'],
  standalone: false,
})
export class ViewYourTruckComponent {
  @Input() main: Main;
}
